import { Controller } from "@hotwired/stimulus"

// Sets a turbo-frame src on demand (e.g. when opening a modal), so the
// request only runs after an explicit user action.
export default class extends Controller {
  static values = { id: String, url: String }

  load() {
    const frame = document.getElementById(this.idValue)
    if (!frame || !this.urlValue) return
    if (frame.getAttribute("src") === this.urlValue) return

    frame.setAttribute("src", this.urlValue)
  }

  activate(event) {
    if (event.key !== "Enter" && event.key !== " ") return

    event.preventDefault()
    // Same as a native button: click opens the Bootstrap modal and runs #load.
    this.element.click()
  }
}
